import { TelenganaNorthenApiService } from "../httpsservice/ApiService";


export const fetchTransactionDataTGN = async ({params}) =>{
    const { txn_id } = params;
    const queryData = { txn_id: txn_id };
    
      const response = await TelenganaNorthenApiService.fetchTxnDetails(queryData);
      if (response.data && response.success) {
        return response.data;
      } else {
        throw new Response("Failed to fetch", { status: response.status });
      }
}
